import domReady from "@wordpress/dom-ready";
import { createRoot } from "@wordpress/element";
import { AmerequipForm } from "./AmerequipForm";

domReady(() => {
  const mount = document.getElementById("amerequip-react-root");
  if (!mount) return;

  // Parse the JSON from data attribute
  const rawData = mount.dataset.form;
  let parsedData = {};
  try {
    parsedData = JSON.parse(rawData);
  } catch (err) {
    console.error("Invalid JSON in data-form:", err);
  }

  const root = createRoot(mount);
  root.render(<AmerequipForm data={parsedData} />);
});
